import classNames from 'classnames';
import React, { MouseEvent, ReactNode } from 'react';
import { Link } from '../Link';

export type TileProps = {
  children: ReactNode;
  headline?: string;
  fullHeight?: boolean;
  link?: {
    label: string;
    href: string;
  };
  onClick?(e: MouseEvent<HTMLDivElement>): void;
  fullWidth?: boolean;
  tileLink?: string;
};

export const Tile: React.FC<TileProps> = ({
  fullHeight,
  children,
  headline,
  link,
  onClick,
  tileLink,
}: TileProps) => {
  const content = (
    <div
      className={classNames('rounded-4px  border-grey-300 border', {
        'hover:shadow-2dp cursor-pointer': onClick || link,
      })}
      onClick={onClick}
      data-testid="tile-outer"
    >
      <div
        className={classNames(
          'rounded-4px  flex flex-col justify-between bg-white p-3',

          { 'h-full': fullHeight },
          { 'hover:bg-grey-100': tileLink },
        )}
      >
        <div>
          {headline && (
            <div className="mb-3">
              <span className="text-2xs font-sans uppercase tracking-widest">
                {headline}
              </span>
            </div>
          )}

          {children}
        </div>
        {link && (
          <div className="flex justify-end pt-1">
            <Link
              icon="ArrowRight"
              iconPosition="right"
              variant="compact"
              label={link.label.toUpperCase()}
              href={link.href}
            />
          </div>
        )}
      </div>
    </div>
  );
  return (
    <div className={classNames('w-full md:px-2 ', { 'h-full': fullHeight })}>
      {tileLink ? (
        <a href={tileLink} target="_blank" rel="noopener noreferrer">
          {content}
        </a>
      ) : (
        content
      )}
    </div>
  );
};
